module.exports = __webpack_public_path__ + "/images/ico-nav-lists.d3a9c85.png";